import QueryParamsInterface from '@/utilities/gridManager/interfaces/QueryParamsInterface'

export default class QueryParams<T extends Record<string, string | number>> implements QueryParamsInterface {
  private readonly params: T

  constructor(params: T) {
    this.params = params
  }

  toString(): string {
    const paramsAsStrings: Record<string, string> = {}

    Object.keys(this.params).forEach((key: string) => {
      paramsAsStrings[key] = `${this.params[key]}`
    })

    return new URLSearchParams(paramsAsStrings).toString()
  }
}
